<div class="fs-2 with-close" mat-dialog-title>
    Partager la liste
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <p *ngIf="noShareableUsers">
        Le partage de liste est réservé aux comptes d'une même entreprise.
        <ng-container *ngIf="hasCurrentShares"><br/>Cette liste est encore partagée : validez pour retirer le partage.</ng-container>
    </p>
    <ng-container *ngIf="!noShareableUsers">
        <p>
            Cette liste est partagée avec :
        </p>
        <mat-spinner diameter="26" *ngIf="loadingUsers"></mat-spinner>
        <ul>
            <li *ngFor="let u of shareUserIds">
                <mat-checkbox [(ngModel)]="u.share">
                    {{u.name}}
                </mat-checkbox>
            </li>
        </ul>
        <p class="text-grey">
            Attention : Les utilisateurs sélectionnés pourront modifier et supprimer les annonces que la liste partagée contient.
        </p>
    </ng-container>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary" *ngIf="!loadingUsers && (!noShareableUsers || hasCurrentShares)">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Valider</ng-container>
    </button>
</div>
